import React from "react";
import { appIcon } from "go-core/components/Apps/AppIcon";
import { ReactComponent as GoPOSSVG } from "go-core/images/svg/apps/gopos.svg";

interface Props {
	slug: string;
}

export const RenderApplicationLogo = ({ slug }: Props) => {
	if (slug === "GoPOSRetail") return <GoPOSSVG />;
	return appIcon(slug);
};
